import { render, staticRenderFns } from "./renewCensus.vue?vue&type=template&id=20f98cff&scoped=true"
import script from "./renewCensus.vue?vue&type=script&lang=js"
export * from "./renewCensus.vue?vue&type=script&lang=js"
import style0 from "./renewCensus.vue?vue&type=style&index=0&id=20f98cff&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f98cff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f98cff')) {
      api.createRecord('20f98cff', component.options)
    } else {
      api.reload('20f98cff', component.options)
    }
    module.hot.accept("./renewCensus.vue?vue&type=template&id=20f98cff&scoped=true", function () {
      api.rerender('20f98cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/renewCensus.vue"
export default component.exports